// extracted by mini-css-extract-plugin
export var attachment = "_pg-a";
export var emailContainer = "_pg-4";
export var emailContentPaddedContainer = "_pg-b";
export var emailHeader = "_pg-6";
export var emailIframe = "_pg-3";
export var emailInfoIcon = "_pg-9";
export var emailShortenedSummary = "_pg-e";
export var infoDropdown = "_pg-0";
export var infoRowBoundedContent = "_pg-d";
export var internal = "_pg-5";
export var merchant = "_pg-8";
export var messageInputContainer = "_pg-h";
export var normal = "_pg-7";
export var replyCard = "_pg-f";
export var subtleButton = "_pg-1";
export var subtleButtonIconContainer = "_pg-2";
export var toggleViewRepliesButton = "_pg-c";
export var wrappingText = "_pg-g";